export type NzStatisticValueType = number | string;

export const REFRESH_INTERVAL = 1000 / 30;
